module.exports = __webpack_public_path__ + "img/loading_anim.916ea676.svg";